import { render } from "./VerifyEmail.vue?vue&type=template&id=96e87212"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/views/VerifyEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96e87212"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96e87212', __exports__)) {
    api.reload('96e87212', __exports__)
  }
  
  module.hot.accept("./VerifyEmail.vue?vue&type=template&id=96e87212", () => {
    api.rerender('96e87212', render)
  })

}


export default __exports__